import React, { useState, useEffect } from 'react';
import styles from './LoadingScreen.module.css';

const LoadingScreen: React.FC = () => {
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [scanLine, setScanLine] = useState(0);
  const [loadingMessages, setLoadingMessages] = useState<string[]>([]);
  
  useEffect(() => {
    // Simulate loading progress
    const interval = setInterval(() => {
      setLoadingProgress(prev => {
        const newProgress = prev + Math.random() * 10;
        return newProgress > 100 ? 100 : newProgress;
      });
    }, 200);
    
    // Animate scan line
    const scanInterval = setInterval(() => {
      setScanLine(prev => (prev + 1) % 100);
    }, 30);
    
    // List of cyberpunk-style loading messages
    const messages = [
      "Initializing neural interface...",
      "Bypassing security protocols...",
      "Establishing secure connection...",
      "Scanning network for vulnerabilities...",
      "Decrypting matrix access codes...",
      "Loading digital consciousness...",
      "Compiling quantum algorithms...",
      "Searching for system exploits...",
      "Preparing holographic display...",
      "Synchronizing with the grid..."
    ];
    
    // Add new messages periodically
    let messageIndex = 0;
    const messageInterval = setInterval(() => {
      if (messageIndex < messages.length) {
        setLoadingMessages(prev => [...prev, messages[messageIndex]]);
        messageIndex++;
      }
    }, 800);
    
    return () => {
      clearInterval(interval);
      clearInterval(scanInterval);
      clearInterval(messageInterval);
    };
  }, []);
  
  return (
    <div className={styles.loadingScreen}>
      <div className={styles.scanLine} style={{ top: `${scanLine}%` }} />
      <div className={styles.scanEffect} />
      
      <div className={styles.loadingContent}>
        <h1 className={styles.loadingTitle}>
          <span className={styles.glitchText}>SYSTEM BOOT</span>
        </h1>
        
        <div className={styles.loadingMessage}>Initializing Matrix Interface...</div>
        
        <div className={styles.progressWrapper}>
          <div className={styles.progressContainer}>
            <div className={styles.progressBar} style={{ width: `${loadingProgress}%` }} />
          </div>
          <div className={styles.progressText}>{Math.floor(loadingProgress)}%</div>
        </div>
        
        <div className={styles.loadingDetails}>
          {loadingMessages.map((message, index) => (
            <div key={index} className={styles.loadingDetail}>
              <span className={styles.loadingPrefix}>&gt;</span> {message}
            </div>
          ))}
          <div className={styles.cursor} />
        </div>
        
        <div className={styles.accessText}>
          <span className={styles.blink}>ACCESS PENDING...</span>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;